import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { unrateApp } from 'queries';

export default new AsyncActionHandler({
  name: 'unrate_app',
  handler: (id) => async () => {
    const { data } = await apollo.mutate({
      mutation: unrateApp,
      variables: {
        id
      }
    });

    return {
      app: data.unrateApp
    };
  },
  reduce(state, { app }) {
    if (!app) {
      return state;
    }

    return {
      apps: {
        ...state.apps,
        [app.id]: app
      }
    };
  }
});
